import { cn } from "../../utils";
import { NINJATRADER_TRADEMARK_TEXT } from "./ninjaTraderTrademarkText";

export { NINJATRADER_TRADEMARK_TEXT };

type NinjaTraderTrademarkNoticeProps = {
  className?: string;
  /**
   * "callout" (default): bordered, tinted box for in-page placement.
   * "plain": bare paragraph, for the site-wide disclosure footer.
   */
  variant?: "callout" | "plain";
};

/**
 * Must appear on any page that mentions NinjaTrader. Placed today on
 * /integrations, /disclosures and, via the disclosure footer, on the landing
 * page (SocialProofBar shows the NinjaTrader logo).
 */
export default function NinjaTraderTrademarkNotice({
  className,
  variant = "callout",
}: NinjaTraderTrademarkNoticeProps) {
  if (variant === "plain") {
    return <p className={className}>{NINJATRADER_TRADEMARK_TEXT}</p>;
  }
  return (
    <div
      className={cn(
        "rounded-md border border-border bg-muted/40 px-4 py-3 text-xs leading-relaxed text-muted-foreground",
        className,
      )}
    >
      {NINJATRADER_TRADEMARK_TEXT}
    </div>
  );
}
